var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group-wrapper"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"4"}},[_c('div',{staticClass:"button-box shadow"},[_c('modal')],1)]),_c('last-updated-draft'),_c('info-tour')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }